import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import FilterClientForm from './FilterClientForm';
import ClientListing from './ClientListing';
import ClientReport from './ClientReport';
import {
  loadClientData
} from '../../actions/advisor';
import s from './AdvisorMode.css';

class AdvisorMode extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showAddClient: false,
    };
  }

  componentWillMount() {
    this.props.loadClientData();
  }

  render() {
    const{ reportClient } = this.props;
    return (
      <div className={s.bhvfin}>
        <div className="row">
          <div className="col-md-12">
            <div className={s.headerTitle}>BEHAVIORAL FINANCE DASHBOARD</div>
          </div>
        </div>
        { reportClient &&
          <ClientReport />
        }
        { !reportClient &&
          <div>
            <FilterClientForm />
            <ClientListing />
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    reportClient: state.advisorData.reportClient,
  };
}

export default connect(mapStateToProps, {
  loadClientData,
})(AdvisorMode);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/AdvisorMode.js